import React from 'react';
import SaveBtn from '../../save-button';
import withPopover from '../hoc/with-popover';

const SaveButton = (props) => <SaveBtn {...props} />;

export default withPopover(SaveButton);
